type Props = {
  children: JSX.Element,
  actions: JSX.Element
};

function ElementActions({children, actions}: Props) {
  return (
    <div className="flex items-center justify-between w-full">
      <div className="flex-1">
        { children }
      </div>
      <div className="flex-shrink-0 ml-2 flex items-center space-x-2">
        { actions }
      </div>
    </div>
  );
}

export default ElementActions;
